import { BProgress } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBProgress when migrating. */
export const EgBProgress = createEgBootstrapProxy("EgBProgress", BProgress);
